import { render, staticRenderFns } from "./BjTable.vue?vue&type=template&id=78f0c9c6"
import script from "./BjTable.vue?vue&type=script&lang=js"
export * from "./BjTable.vue?vue&type=script&lang=js"
import style0 from "./BjTable.vue?vue&type=style&index=0&id=78f0c9c6&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f0c9c6')) {
      api.createRecord('78f0c9c6', component.options)
    } else {
      api.reload('78f0c9c6', component.options)
    }
    module.hot.accept("./BjTable.vue?vue&type=template&id=78f0c9c6", function () {
      api.rerender('78f0c9c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjTable/BjTable.vue"
export default component.exports